// extracted by mini-css-extract-plugin
module.exports = {"tag_popup_container":"TagPopup_tag_popup_container__fglgo","option_container":"TagPopup_option_container__1VwXM","contact_tag":"TagPopup_contact_tag__1uNVh"};